import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['input', 'tabs']

  change(event) {
    this.inputTarget.value = event.currentTarget.dataset.value
  }

}
